import FulfillmentPlanResource from "./fulfillmentPlan.resource";

const fulfillmentPlanModule = angular
  .module("app.resources.fulfillmentPlan", [])
  .service("FulfillmentPlan", FulfillmentPlanResource);

export default fulfillmentPlanModule;



// WEBPACK FOOTER //
// ./src/resources/fulfillmentPlan/fulfillmentPlan.module.js